import styless from '@/views/fin/salaryadministration/components/pay.module.less'
export const employee_type = {
    // 正式员工
    1: [ 
        {
            title:'正式员工',
            customer_type_val: 0,
            customer_sub_type_val: 0,
        }
    ],
    // 大规模用工
    2: [ 
        {
            title:'正式员工（大规模）',
            customer_type_val: 50,
            customer_sub_type_val: 0,
        }
    ],
    // 劳务派遣
    3: [ 
        {
            title:'劳务派遣',
            customer_type_val: 20,
            customer_sub_type_val: -1,
        }
    ],
    4: [ 
        {
            title:'劳务派实习生（外包）',
            customer_type_val: 10,
            customer_sub_type_val: 1,
        },
        {
            title:'外包（大规模）',
            customer_type_val: 50,
            customer_sub_type_val: 2,
        },
        {
            title:'外包员工',
            customer_type_val: 40,
            customer_sub_type_val: -1,
        },
    ],
}

export const adjust_type_hash = {
    promote: '晋升调薪',
    job_transfer: '转岗调薪',
    transfer_regular: '转正调薪',
    other: '其他调薪',
    year: '年度薪酬review',
    init: '',
}

export const adjust_type_list = [
    {
        label: '晋升调薪',
        value: 'promote'
    },
    {
        label: '转岗调薪',
        value: 'job_transfer'
    },
    {
        label: '转正调薪',
        value: 'transfer_regular'
    },
    {
        label: '其他调薪',
        value: 'other'
    },
    {
        label: '年度薪酬review',
        value: 'year'
    }
]


export const adjust_level_list = [
    {
        label: '员工',
        value: 'normal'
    },
    {
        label: '部门负责人',
        value: 'leader'
    },
    {
        label: '高管',
        value: 'senior_leader'
    }
]

export const customer_type_list = [
    {
        label: '正式-产研',
        value: 1
    },
    {
        label: '挂靠员工',
        value: 0
    },
]

export const adjust_level_title_hash = adjust_level_list.reduce((total, item) => {
    total[item.value] = item.label
    return total
}, {})


export const radio_keys = [
     'company_accumulation_fund_ratio', 
     'company_endowment_ratio',
     'company_industrial_injury_ratio', 
     'company_maternity_ratio', 
     'company_medical_ratio', 
     'company_supplementary_medical_ratio', 
     'company_unemployment_ratio', 
     'person_accumulation_fund_ratio', 
     'person_endowment_ratio', 
     'person_industrial_injury_ratio', 
     'person_maternity_ratio', 
     'person_medical_ratio', 
     'person_unemployment_ratio', 
]

export const status_list = [
    {
        title: '重名人员',
        // color: '#FFF176',
        value: 'same_name',
        className: styless['cm'],
        key: ['same_name_flag'],
    },
    {
        title: '21-25号换签',
        // color: '#B9F6CA',
        value: 'current_change',
        className: styless['current-change-flag'],
        key: ['current_change_flag']
    },
    {
        title: '21-25号通过离职审批',
        // color: '#B3E5FC',
        value: 'current_quit',
        className: styless['current-quit-flag'],
        key: ['current_quit_flag']
    },
    // {
    //     title: '医疗期',
    //     // color: '#FFCCBC',
    //     value: 'pre_medical_period',
    //     className: styless['current-medical-period-flag'],
    //     key: ['current_medical_period_flag', 'pre_medical_period_flag']
    // }
]

export const emp_status_list = ['本期入职', '本期离职', '本期入离职', '离职中', '本期调动', '本期实习转正', '特殊发放']

export const status_hash = {
    confirmed:{
        title: '已确认',
        dis_color: '#19be6b',
        dis_cursor: ''
    },
    wait_confirm: {
        title: '待确认',
        dis_color: '#1976d2',
        dis_cursor: 'pointer'
    },
    rebutted:  {
        title: '已驳回',
        dis_color: '#F44336',
        dis_cursor: ''
    },
}

export const other_give_out = [
    {
        value: 1,
        title: '是'
    },
    {
        value: 0,
        title: '否'
    }
]